// @core/api/endpoints/task/create_task_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTaskPolicyRequest,
  TaskPolicyResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Create task policy
 * Creates a task management policy for a scope entity (project, team, department, organization). Configures default task types, numbering, templates, and behavior rules.
 */
export async function CreateTaskPolicy(
  data: CreateTaskPolicyRequest,
  options?: RequestOptions
): Promise<TaskPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-policies`;
  const requestOptions = options;
  return client.post<TaskPolicyResponse>(requestPath, data, requestOptions);
}
